
<section class="workspace-label">
  <section-label
    class="section-label"
    [sectionLabelContent]="compositeActivitiesName"
  ></section-label>
</section>

<section class="switch-main-div workspace-container">
  <!-- [ngSwitch]="assignment?.assignableType" -->
  <!--<div *ngSwitchDefault>
  Unable to load assignment data for type:
  {{ assignment?.assignableType }}
</div>-->

@if (
  (assignment?.assignableType === assetTypeIds.BUNDLE &&
  assignment?.asset?.assetActivityTypeId !==
  assetActivityTypeIds.IPA) ||
  assignment?.assignableType === assetActivityTypeIds.MATHIA_UNIT
  ) {
  <div
    class="view-composite-assignment-workspace-container"
    >
    <p class="activityInstructions">{{ activityInstructions }}</p>
    <mat-expansion-panel class="bundle-details-panel" [expanded]="true">
      <mat-expansion-panel-header
        class="bundle-details-panel-header"
        collapsedHeight="auto"
        expandedHeight="auto"
        >
        <div class="bundle-header-container">
          <!-- border -->
          <section class="bundle-border-section">
            <div class="bundle-border"></div>
          </section>
          <section class="bundle-header-main">
            <!-- Bundle Title -->
            <div class="bundle-details-title">
              <img
                class="bundle-title-icon icon-33-x-33"
                [src]="getIconPath(assignment?.asset)"
                alt="Bundle Activity Assignable Type"
                />
              <h3 class="bundle-title-h3">
                {{ getAssignmentName(assignment) }}
              </h3>
            </div>
            <!-- bundle main info -->
            <div class="bundle-main-info-container">
              <!-- Bundle Activity Count -->
              <section class="bundle-sections">
                <h4 class="bundle-details-labels">
                  Total Activities
                </h4>
                <div>
                  <span>{{
                    assignment.compositeTaskAssignments
                    .length
                  }}</span>
                </div>
              </section>
            </div>
          </section>
        </div>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <workspace-details
          class="workspace-container"
                    [compositeTaskAssignments]="
                        assignment.compositeTaskAssignments
                    "
          [assignment]="assignment"
          [course]="course"
          [userProfile]="userProfile"
          [maxAttemptsUpdated]="maxAttemptsUpdated"
          [bundleWithEbook]="bundleWithEbook"
          (resetBundleActivityStatusFn)="resetStatus($event)"
          >
        </workspace-details>
      </ng-template>
    </mat-expansion-panel>
  </div>
}

@if (assignment?.assignableType === assetActivityTypeIds.IPA) {
  <div
    class="view-composite-assignment-workspace-container-IPA"
    >
    <p>
      Each activity should be viewed and considered when grading this
      assignment. Use the
      <a href="{{ getIPAScoringGuideUrl(assignment) }}" target="_blank"
        >{{ getLevelDisplayName(assignment) }} Rubrics for Scoring
        Document</a
        >
        as a guide to assess student submissions.
      </p>
      <!-- If more than one Level exists for this IPA, show the other guides -->
      @if (
        assignment &&
        assignment.asset &&
        assignment.asset.levelIds &&
        assignment.asset.levelIds.length > 1
        ) {
        <ul
          >
          @for (levelId of assignment.asset.levelIds; track levelId; let i = $index) {
            <li
              [ngClass]="{ 'hide-first-guide': i === 0 }"
              >
              <a
                href="{{ getIPAScoringGuideUrl(assignment, levelId) }}"
                target="_blank"
                >{{ getLevelDisplayName(assignment, levelId) }} Rubrics for
                Scoring Document</a
                >
              </li>
            }
          </ul>
        }
        <p class="activityInstructions">{{ activityInstructions }}</p>
        @for (
          compositeTaskAssignment of assignment.compositeTaskAssignments
          ; track
          compositeTaskAssignment) {
          <mat-expansion-panel
            #expPanel
            [ngClass]="{ 'panel-expanded': expPanel.expanded }"
            class="mat-expansion-panel-IPA task-panel"
            [disabled]="checkIfNoComposite(compositeTaskAssignment)"
            [fxHide]="
                !compositeTaskAssignment?.compositeTaskAssignmentID &&
                !compositeTaskAssignment?.completedAt
            "
            >
            <mat-expansion-panel-header
              collapsedHeight="auto"
              expandedHeight="auto"
              >
              @if (compositeTaskAssignment?.compositeTaskAssignmentID) {
                <div
                  class="panel-header"
                  fxFlex="100"
                  fxLayout="row"
                  fxLayout.lt-sm="column"
                  fxLayoutAlign="space-between center"
                  fxLayoutAlign.lt-sm="center start"
                  >
                  <div
                    class="assignment-name"
                    fxLayout="row"
                    fxLayoutAlign="start"
                        [ngClass]="{
                            'collapsed-header-iconAndType': !expPanel.expanded
                        }"
                    style="overflow: hidden"
                    >
                    @if (showResetButton(compositeTaskAssignment)) {
                      <div
                        class="reset-button-container"
                        >
                        <button
                          type="button"
                          mat-raised-button
                          color="primary"
                                [disabled]="
                                    disableResetButton(compositeTaskAssignment)
                                "
                                (click)="
                                    $event.stopPropagation();
                                    resetStatus(
                                        compositeTaskAssignment?.compositeTaskAssignmentID
                                    )
                                "
                          >
                          Reset Activity
                        </button>
                      </div>
                    }
                    <div>
                      <img
                        class="panel-header-icon"
                        aria-label="Bundle Activity Assignable Type"
                                [src]="
                                    getIconPath(compositeTaskAssignment?.asset)
                                "
                        [ngClass.xs]="'panel-header-icon-xs'"
                                [ngClass]="{
                                    'expanded-icon': expPanel.expanded
                                }"
                        />
                    </div>
                    <div
                      fxLayout="column"
                      class="panel-header-text"
                      fxLayoutAlign="center start"
                      >
                      @if (compositeTaskAssignment?.startedAt) {
                        <span
                          class="started-at-date"
                          >
                          <span>Started at: </span>
                          <span
                                    innerHTML="{{
                                        getDate(
                                            compositeTaskAssignment?.startedAt
                                        )
                                    }}"
                          ></span>
                        </span>
                      }
                      <span
                        class="header-assignment-name"
                                [matTooltip]="
                                    compositeTaskAssignment?.asset?.displayName
                                "
                        [ngClass.xs]="'header-assignment-name-xs'"
                                [ngClass]="{
                                    'header-assignment-type-expanded':
                                        expPanel.expanded
                                }"
                                [innerHTML]="
                                    compositeTaskAssignment?.asset?.displayName
                                "
                      ></span>
                    </div>
                  </div>
                </div>
              }
              @if (
                !compositeTaskAssignment?.compositeTaskAssignmentID &&
                compositeTaskAssignment?.completedAt
                ) {
                <div
                  class="panel-header"
                  fxFlex="100"
                  fxLayout="row"
                  fxLayout.lt-sm="column"
                  fxLayoutAlign="space-between center"
                  fxLayoutAlign.lt-sm="center start"
                  >
                  <div
                    class="assignment-name"
                    fxLayout="row"
                    fxLayoutAlign="start"
                        [ngClass]="{
                            'collapsed-header-iconAndType': !expPanel.expanded
                        }"
                    style="overflow: hidden"
                    >
                    You have removed this activity from the Bundle. The
                    student submitted it on
                    {{ getDate(compositeTaskAssignment.completedAt) }}
                  </div>
                </div>
              }
            </mat-expansion-panel-header>
            @if (expPanel.expanded) {
              <view-assignment
                [assignment]="compositeTaskAssignment"
              ></view-assignment>
            }
          </mat-expansion-panel>
        }
      </div>
    }
  </section>
